var lib_core      = require("lib-core");
var lib_geometry      = require("lib-geometry");
var THREE         = require("three");
var Handle3dModel  = require("./../../../abstract/handle3dModel.js");

var GuiHandleModel = function (editorModel, handleId) {
    Handle3dModel.call(this, editorModel, handleId);
};

lib_core.inherit(GuiHandleModel, Handle3dModel);
GuiHandleModel.$class = "GuiHandleModel";
module.exports = GuiHandleModel;


GuiHandleModel.prototype.getSubjectsCenter = function(){
    console.error("not implimented");
} 

// GuiHandleModel.prototype.getSubjectsRadius = function(){
//     console.error("not implimented");
// } 

GuiHandleModel.prototype.getSubjectsRotation = function(){
    return 0;
} 

GuiHandleModel.prototype.createMovementPlane = function(ray, point){}

GuiHandleModel.prototype.setContactPosition = function(position){}

GuiHandleModel.prototype.setMousePosition = function(position){}

GuiHandleModel.prototype.released = function(){}